export default __webpack_public_path__ + "static/media/i-documento-connect.c2ec5b15.svg";